var map = {
	"./bg-circle.png": "e71f",
	"./bg-rectangle.png": "703d",
	"./bg-squre.png": "4db1",
	"./bg-triangle.png": "7ebb",
	"./box.png": "2172",
	"./car.png": "29ac",
	"./circle.png": "55bc",
	"./download.png": "8eed",
	"./ellipsis.png": "2127",
	"./home.png": "593c",
	"./leaf.png": "9231",
	"./note.png": "2c26",
	"./squre.png": "3943"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6e40";